export default __webpack_public_path__ + "static/media/hot.13f83bf6.svg";